import { render, staticRenderFns } from "./TenantShowContactsTab.vue?vue&type=template&id=58d1c6fd"
import script from "./TenantShowContactsTab.vue?vue&type=script&lang=ts"
export * from "./TenantShowContactsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports